import { Outlet } from 'react-router-dom'; // Il contenuto dinamico verrà renderizzato qui

export default function Full() {
  	return (
        <Outlet />
	);
}